import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export default function AdminServices() {
  const [rows, setRows] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/services").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.patch(`/admin/services/${editing.slug}`, editing);
      toast.success("Service mis à jour");
      setEditing(null); load();
    } catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div>
      <div className="font-heading text-3xl font-black uppercase tracking-tight">Services</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {rows.map((s) => (
          <div key={s.slug} className="bg-ink-900 border border-ink-700 p-5">
            <div className="flex items-start justify-between gap-2">
              <div className="font-heading text-lg font-bold uppercase tracking-tight">{s.title}</div>
              <span className={`text-xs px-2 py-0.5 ${s.active ? "bg-brand/20 text-brand" : "bg-ink-800 text-zinc-500"}`}>{s.active ? "Actif" : "Inactif"}</span>
            </div>
            <div className="text-xs text-zinc-500 mt-1">/services/{s.slug}</div>
            <p className="text-zinc-400 text-sm mt-2 line-clamp-3">{s.short_description}</p>
            <button onClick={() => setEditing({ ...s })} className="mt-3 text-brand text-xs font-bold uppercase tracking-widest" data-testid={`service-edit-${s.slug}`}>Éditer →</button>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-ink-900 border border-ink-700 p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="font-heading text-2xl font-black uppercase tracking-tight">Éditer : {editing.title}</div>
            <div className="grid gap-3 mt-4">
              <Field label="Titre" value={editing.title} onChange={(v) => setEditing((e) => ({ ...e, title: v }))} />
              <Field label="Tarif indicatif" value={editing.tarif_indicatif} onChange={(v) => setEditing((e) => ({ ...e, tarif_indicatif: v }))} />
              <Field label="Description courte" value={editing.short_description} onChange={(v) => setEditing((e) => ({ ...e, short_description: v }))} textarea />
              <Field label="Description longue" value={editing.long_description} onChange={(v) => setEditing((e) => ({ ...e, long_description: v }))} textarea />
              <Field label="URL image" value={editing.image_url} onChange={(v) => setEditing((e) => ({ ...e, image_url: v }))} />
              <Field label="Meta title" value={editing.meta_title} onChange={(v) => setEditing((e) => ({ ...e, meta_title: v }))} />
              <Field label="Meta description" value={editing.meta_description} onChange={(v) => setEditing((e) => ({ ...e, meta_description: v }))} textarea />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing((s) => ({ ...s, active: e.target.checked }))} /> Actif (visible publiquement)</label>
            </div>
            <div className="mt-5 flex gap-2 justify-end">
              <button onClick={() => setEditing(null)} className="px-4 py-2 border border-ink-700 text-zinc-300">Annuler</button>
              <button onClick={save} className="bg-brand text-white font-bold uppercase px-5 py-2 inline-flex items-center gap-2"><Save size={14} /> Enregistrer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, value, onChange, textarea }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-widest text-zinc-500">{label}</span>
      {textarea ? (
        <textarea className="mt-1 w-full px-3 py-2 bg-ink-800 border border-ink-700 focus:border-brand text-white outline-none min-h-[80px]" value={value || ""} onChange={(e) => onChange(e.target.value)} />
      ) : (
        <input className="mt-1 w-full h-10 px-3 bg-ink-800 border border-ink-700 focus:border-brand text-white outline-none" value={value || ""} onChange={(e) => onChange(e.target.value)} />
      )}
    </label>
  );
}
